import { render, staticRenderFns } from "./TabPrecificacaoDocumento.vue?vue&type=template&id=2c9d70bf&"
import script from "./TabPrecificacaoDocumento.vue?vue&type=script&lang=js&"
export * from "./TabPrecificacaoDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports